import _ from 'lodash';
import { TREND_TOOLS } from '@/toolSelection/investigate.constants';
import { BaseToolStore } from '@/toolSelection/baseTool.store';
import { BASE_TOOL_COMMON_PROPS } from '@/toolSelection/baseTool.constants';

export class ItemPropertiesStore extends BaseToolStore {
  type = TREND_TOOLS.PROPERTIES;
  static readonly storeName = 'sqItemPropertiesStore';

  initialize() {
    this.state = this.immutable(
      _.defaults(
        {},
        {
          advancedParametersCollapsed: this.state ? this.state.get('advancedParametersCollapsed') : undefined,
          duplicatingItemId: '',
        },
        _.pick(BASE_TOOL_COMMON_PROPS, 'advancedParametersCollapsed'),
      ),
    );
  }

  get duplicatingItemId(): string {
    return this.state.get('duplicatingItemId');
  }

  /**
   * Exports state so it can be used to re-create the state later using `rehydrate`.
   *
   * @return {Object} State for the store
   */
  dehydrate() {
    return this.state.serialize();
  }

  /**
   * Sets the references panel state
   *
   * @param dehydratedState - Previous state usually obtained from `dehydrate` method.
   */
  rehydrate(dehydratedState: object) {
    this.state.merge(dehydratedState);
  }

  protected readonly handlers = {
    ...this.baseHandlers,
    PROPERTIES_SET_DUPLICATING_ITEM_ID: ({ id }: { id: string }) => {
      this.state.set('duplicatingItemId', id);
    },
  };
}
